import { motion, useScroll, useSpring } from "framer-motion";

// Barra sottile in alto che mostra l'avanzamento dello scroll (effetto neon).
export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.3 });
  return (
    <motion.div
      style={{ scaleX }}
      className="fixed top-0 left-0 right-0 z-[60] h-1 origin-left bg-gradient-to-r from-primary via-accent to-primary"
      aria-hidden="true"
    />
  );
};
